module.exports = __webpack_public_path__ + "img/1.34ca71e1.jpg";